import { Icon, type IconProps } from './Icon';

/** Abre menu ou seção. Substitui o `▾`; para `▴`, gire com CSS. */
export function ChevronDownIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="m6 9 6 6 6-6" />
    </Icon>
  );
}
